import React from "react";
import "./styles.scss";

const Description = (props) => {
  const { answer, question } = props;
  return (
    <div className="description-containers">
      <h3>{question}</h3>
      <p dangerouslySetInnerHTML={{ __html: answer }} />
    </div>
  );
};

export default Description;
